<template>
  <form role="search">
    <h2>Search Top Headlines</h2>
    <button id="clear" type="button" v-on:click="handleClear" :disabled="keyword === ''">Clear</button>
    <input autocomplete="off" id="search" maxlength="30" v-model="keyword" placeholder="Search news">
    <pre v-show="error" class="error">
      {{error}}
    </pre>
  </form>
</template>

<script>
export default {
  props: {
    search: String,
    onSearch: Function,
    handleSearch: Function,
    onClear: Function,
    handleFilter: Function,
    error: String,
    news: Array,
  },
  data() {
    return {
      keyword: '',
    };
  },
  watch: {
    keyword(newV, oldV) {
      if(newV !== oldV) {
        if(newV === '') {
          this.onClear();
        }
        this.handleSearch(this.keyword);
        this.handleFilter(newV);
      }
    }
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault();
      if(this.search === '' || this.search !== this.keyword) {
        this.handleFilter(this.keyword);
      }
    },
    handleClear() {
      this.keyword = '';
      this.onClear();
    },
  }
};
</script>

<style>
form {
  display: block;
  white-space: nowrap;
}
input, button#clear {
  border-radius: 12px;
}
input {
  border: 2px solid rgb(var(--color-turquoise) / 1);
  padding: 0.25em 1rem;
  width: 180px;
  margin-inline: 0.5rem;
}
button#clear {
  background-color: rgb(var(--color-turquoise) / 1);
  box-shadow: var(--box-shadow-lg);
  height: 2.25rem;
  width: 3.5em;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
}
button#clear[disabled] {
  background-color: rgb(var(--black-100) / 0.2);
  color: rgb(var(--black-100) / 0.5);
  cursor: not-allowed;
}
</style>
